<img
  *ngIf="iconPath"
  class="datasource-type-icon"
  src="{{ iconPath }}"
  [alt]="featureType + ' type child icon'"
  [ngClass]="customClasses"
/>
